<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">待盖章</el-menu-item>
		  <el-menu-item index="list2">已盖章</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
			<dSeal v-if="activeIndex == 'list'" ></dSeal>
			<ySeal v-else-if="activeIndex == 'list2'"></ySeal>
      </div>
    </div>
  </div>
</template>

<script>
import dSeal from './dSeal.vue';
import ySeal from './ySeal.vue';
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
	  restId:null,
    };
  },
  components: {
	dSeal,
	ySeal,
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath){
	  console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>